import { FileWarning, Loader2 } from "lucide-react";

export function WindowSkeleton() {
  return (
    <div className="h-full w-full p-6 space-y-4" data-testid="window-loading">
      <div className="flex items-center gap-2 font-mono text-[11px] text-slate-500">
        <Loader2 size={12} className="animate-spin text-sonoma" />
        launching…
      </div>
      <div className="skeleton h-7 w-2/5 rounded-md" />
      <div className="skeleton h-3 w-3/4 rounded-md" />
      <div className="skeleton h-3 w-2/3 rounded-md" />
      <div className="grid grid-cols-2 gap-3 pt-2">
        <div className="skeleton h-20 rounded-xl" />
        <div className="skeleton h-20 rounded-xl" />
        <div className="skeleton h-20 rounded-xl" />
        <div className="skeleton h-20 rounded-xl" />
      </div>
      <div className="skeleton h-3 w-1/2 rounded-md" />
    </div>
  );
}

export function EmptyState({ title, hint, testid = "empty-state" }) {
  return (
    <div className="flex h-full min-h-[160px] w-full flex-col items-center justify-center gap-2 rounded-xl border border-dashed border-white/12 p-8 text-center" data-testid={testid}>
      <FileWarning size={20} className="text-slate-500" />
      <p className="font-mono text-sm text-slate-300">{title}</p>
      {hint ? <p className="font-mono text-xs text-slate-500">{hint}</p> : null}
    </div>
  );
}
